import React from "react";
import Unauthorised from "../common/Unauthorised";
import V2App from "../v2/main";
import ClientsWrapper from "../v2/components/clients/ClientsWrapper/ClientsWrapper";
import ClinicianWrapper from "../v2/components/clinicians/ClinicianWrapper/ClinicianWrapper";
import V2InactiveClientMasterView from "../v2/components/clients/InactiveClientMasterView/InactiveClientMasterView";
import AvailabilityWrapper from "../v2/components/availability/AvailabilityWrapper/AvailabilityWrapper";
import V2EmailSignatures from "../v2/components/admin/email-signatures/EmailSignatures/EmailSignatures";
import V2ManageExperienceLevels from "../v2/components/admin/ManageExperienceLevels/ManageExperienceLevels";
import V2ManageMethodology from "../v2/components/admin/ManageMethodology/ManageMethodology";
import V2UserManagement from "../v2/components/admin/UserManagement/UserManagement";
import SentEmailsWrapper from "../v2/components/admin/SentEmailsWrapper/SentEmailsWrapper";
import V2OfficeWindow from "../v2/components/admin/OfficeWindow/OfficeWindow";
import V2OfficeManagement from "../v2/components/office-managers/OfficeManagement/OfficeManagement";
import ConfigurationsWrapper from "../v2/components/admin/configurations/ConfigurationsWrapper/ConfigurationsWrapper";
import DiagnosticsWrapper from "../v2/components/admin/diagnostics/DiagnosticsWrapper/DiagnosticsWrapper";
import CareCoordinators from "../v2/components/assignment/CareCoordinators";
import LoginPage from "../v2/components/LoginPage/LoginPage";
import MyTimeOff from "../v2/components/assignment/MyTimeOff";
export enum AppRoute {
    TIME_OFF = "/time-off",
    BOOKED_CLIENTS = "/booked-clients",
    CLINICIAN_AVAILABILITY = "/availability",
    CLIENT_FULL_VIEW = "/client-full-view",
    CLIENT_MASTER_LIST = "/client-master-list",
    CLINICIANS = "/clinicians",
    REQUEST_OFFICE_WINDOW = "/request-office-window",
    CONFIGURATIONS_HOME = "/configurations",
    DIAGNOSTICS = "/diagnostics",
    EXPERIENCE_CONFIG = "/experience-config",
    FIND_CLINICIAN = "/find-clinician",
    INACTIVE_CLIENT_VIEW = "/view-inactive-client",
    INTAKE_CLINCIAN_AVAILABILITY = "/intake-c-a",
    INTAKE_QUEUE = "/clients",
    MAIN = "/main",
    MANAGE_SUPERVISEE = "/manage-supervisee",
    OFFICE_WINDOWS = "/office",
    OUTBOUND_EMAILS = "/email",
    SUPERVISEES = "/supervisees",
    UNAUTHORISED = "/unauthorised",
    USER_MANAGEMENT = "/users",
    CARE_COORDINATORS = "/care-coordinators",
    EMAIL_SIGNATURES = "/email-signatures",
    OFFICE_MANAGEMENT = "/office-management",
    WAITLIST = "/waitlist",
    LOGIN = "/login",
    LOGOUT = "/logout",
    INTAKE_OTHER = "/intake-other",
}

export function getRoutePaths(routePath: AppRoute) {
    return [routePath, `/v1${routePath}`, `/v2${routePath}`];
}

type AccessControlledRoutes = {
    path: AppRoute;
    component: JSX.Element;
};

export const accessControlledRoutes: AccessControlledRoutes[] = [
    { path: AppRoute.CARE_COORDINATORS, component: <CareCoordinators /> },
    { path: AppRoute.TIME_OFF, component: <MyTimeOff /> },
    {
        path: AppRoute.DIAGNOSTICS,
        component: <DiagnosticsWrapper />,
    },
    {
        path: AppRoute.LOGIN,
        component: <LoginPage />,
    },
    {
        path: AppRoute.FIND_CLINICIAN,
        component: <ClinicianWrapper />,
    },
    {
        path: AppRoute.CLINICIAN_AVAILABILITY,
        component: <AvailabilityWrapper />,
    },
    {
        path: AppRoute.EMAIL_SIGNATURES,
        component: <V2EmailSignatures />,
    },
    {
        path: AppRoute.REQUEST_OFFICE_WINDOW,
        component: <ClinicianWrapper />,
    },
    {
        path: AppRoute.OFFICE_MANAGEMENT,
        component: <V2OfficeManagement />,
    },
    {
        path: AppRoute.CLINICIANS,
        component: <ClinicianWrapper />,
    },
    {
        path: AppRoute.OFFICE_WINDOWS,
        component: <V2OfficeWindow />,
    },

    {
        path: AppRoute.INTAKE_QUEUE,
        component: <ClientsWrapper />,
    },
    {
        path: AppRoute.WAITLIST,
        component: <ClientsWrapper />,
    },
    {
        path: AppRoute.INACTIVE_CLIENT_VIEW,
        component: <V2InactiveClientMasterView />,
    },
    {
        path: AppRoute.CLIENT_FULL_VIEW,
        component: <ClientsWrapper />,
    },
    {
        path: AppRoute.BOOKED_CLIENTS,
        component: <ClientsWrapper />,
    },
    {
        path: AppRoute.INTAKE_CLINCIAN_AVAILABILITY,
        component: <AvailabilityWrapper />,
    },
    {
        path: AppRoute.MANAGE_SUPERVISEE,
        component: <AvailabilityWrapper />,
    },
    {
        path: AppRoute.CLIENT_MASTER_LIST,
        component: <ClientsWrapper />,
    },
    {
        path: AppRoute.EXPERIENCE_CONFIG,
        component: <V2ManageExperienceLevels />,
    },
    {
        path: AppRoute.INTAKE_OTHER,
        component: <V2ManageMethodology />,
    },
    {
        path: AppRoute.USER_MANAGEMENT,
        component: <V2UserManagement />,
    },

    {
        path: AppRoute.OUTBOUND_EMAILS,
        component: <SentEmailsWrapper />,
    },
    {
        path: AppRoute.SUPERVISEES,
        component: <ClinicianWrapper />,
    },
    {
        path: AppRoute.CONFIGURATIONS_HOME,
        component: <ConfigurationsWrapper />,
    },
    {
        path: AppRoute.UNAUTHORISED,
        component: <Unauthorised />,
    },
    {
        path: AppRoute.MAIN,
        component: <V2App />,
    },
];
